/**
 * @generated SignedSource<<cbca3c4a93df34a125a4e5804b27be34>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type CompositionMacroCategoryUpdateInput = {
  displayOrder?: number | null;
  id: number;
  name: string;
};
export type presetConfigurationsQueriesUpdateMacroCategoryMutation$variables = {
  input: CompositionMacroCategoryUpdateInput;
};
export type presetConfigurationsQueriesUpdateMacroCategoryMutation$data = {
  readonly updateMacroCompositionCategory: {
    readonly displayOrder: number;
    readonly id: string;
    readonly macroCategoryID: number;
    readonly name: string | null;
    readonly sellerID: number;
  };
};
export type presetConfigurationsQueriesUpdateMacroCategoryMutation = {
  response: presetConfigurationsQueriesUpdateMacroCategoryMutation$data;
  variables: presetConfigurationsQueriesUpdateMacroCategoryMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "compositionMacroCategory",
        "variableName": "input"
      }
    ],
    "concreteType": "CompositionMacroCategory",
    "kind": "LinkedField",
    "name": "updateMacroCompositionCategory",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "macroCategoryID",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "sellerID",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "displayOrder",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "presetConfigurationsQueriesUpdateMacroCategoryMutation",
    "selections": (v1/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "presetConfigurationsQueriesUpdateMacroCategoryMutation",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "1404db131da2852e526532c3087e4a6d",
    "id": null,
    "metadata": {},
    "name": "presetConfigurationsQueriesUpdateMacroCategoryMutation",
    "operationKind": "mutation",
    "text": "mutation presetConfigurationsQueriesUpdateMacroCategoryMutation(\n  $input: CompositionMacroCategoryUpdateInput!\n) {\n  updateMacroCompositionCategory(compositionMacroCategory: $input) {\n    id\n    macroCategoryID\n    name\n    sellerID\n    displayOrder\n  }\n}\n"
  }
};
})();

(node as any).hash = "bd1c7cc60c8e51d351fe3569d0b00fbf";

export default node;
